import React from 'react';
import PropTypes from 'prop-types';
import trackLead from '../../trackLead';

const PricingCard = props => {
  const { title, price, surveys, responses } = props;

  return (
    <div className="">
      <div className="bg-gray-100 shadow-md rounded-lg content-center flex-col text-center overflow-hidden">
        <div className="bg-shop-dark-green content-center justify-center py-4">
          <h3 className="font-sans text-white tracking-wider uppercase">
            {title}
          </h3>
        </div>
        <div className="p-4">
          <div className="flex flex-row justify-center content-center mb-4">
            <h4 className="font-sans font-bold text-shop-dark-green text-4xl">
              {`$${price}`}{' '}
            </h4>
            <p className="font-sans text-shop-dark-green ml-2 self-center">
              {' '}
              / month
            </p>
          </div>
          <div className="bg-gray-100">
            <div className="flex flex-row mb-4 justify-center items-end">
              <p className="font-sans text-gray-500-dark text-sm mr-2">
                up to{' '}
              </p>
              <p
                className="font-sans text-shop-dark-green text-xl font-bold"
                style={{ lineHeight: '1.25rem' }}
              >
                {surveys || responses}
              </p>
              <p className="font-sans text-gray-500-dark text-sm ml-2">
                {surveys ? 'surveys ' : 'responses'}{' '}
              </p>
            </div>
            <div className="py-6">
              <a
                href="https://apps.shopify.com/shopfeedback"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackLead()}
                className="rounded-full bg-shop-light-green w-auto px-8 py-2 font-sans text-shop-dark-green shadow hover:bg-shop-dark-green hover:text-white transition duration-300 ease-in-out"
              >
                Get Started Today
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PricingCard.propTypes = {
  title: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  surveys: PropTypes.string,
  responses: PropTypes.string,
};

PricingCard.defaultProps = {
  surveys: null,
  responses: null,
};

export default PricingCard;
